<script setup>
import { computed } from 'vue'
import bgSmile from '@/assets/img/bg-smilepicture.png'

const props = defineProps({
    services: {
        type: Array,
        default: () => []
    }
})

// Fallback cards when no API data
const fallbackCards = [
]

// Map service title to route name
const getRouteName = (title) => {
    const routeMap = {
        'Company Profile': 'Company Profile',
        'Campaign Video': 'Campaign Video',
        'Campaign Management': 'Campaign Video',
        'Animation Video': 'Animation Video',
        'TV Commercial Video': 'TV Commercial Video'
    }
    return routeMap[title] || 'Services'
}
const slugify = (title) => {
    return title
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
}

const getServicePath = (service) => {
    const slug = service.slug || slugify(service.title)
    return `/services/${slug}`
}
// Use API services if available, otherwise use fallback
const cards = computed(() => {
    if (props.services.length > 0) {
        return props.services.map(service => ({
            img: service.icon || service.image || '/assets/img/icons/default.png',
            title: service.title,
            desc: service.description || '',
            routeName: getRouteName(service.title),
            path: getServicePath(service)
        }))
    }
    return fallbackCards
})
</script>

<template>
    <section class="wrapper px-0 bg-black" :style="{
        backgroundImage: `url(${bgSmile})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    }">
        <div class="container pt-10 pb-12 pt-md-14 pb-md-16 text-center text-white">

            <!-- HEADER -->
            <h1 class="display-1 mb-3 text-white">
                Our <span class="text-secondary">Services</span>
            </h1>

            <p class="lead mb-8">
                Explore our diverse range of services designed to bring your vision to life. From corporate profiles to
                dynamic campaign videos, our expertise ensures impactful storytelling that resonates with your audience.
            </p>

            <!-- SERVICES CARDS (NEW) -->
            <div class="row g-4">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" v-for="(card, index) in cards" :key="index">
                    <div class="card radius-10 h-100 service-cards p-3">
                        <div class="d-flex align-items-center">
                            <img :src="card.img" alt="icon" class="service-icon" style="width: 4rem; height: 4rem;" />

                            <div class="flex-grow-1 ms-3 text-start">
                                <h3 class="text-secondary mb-2">
                                    {{ card.title }}
                                </h3>
                                <p class="text-light mb-0">
                                    {{ card.desc }}
                                </p>
                            </div>

                            <router-link :to="{ path: card.path }" class="ms-3 arrow-link" aria-label="service detail">
                                <i class="uil uil-arrow-up-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </section>
</template>

<style>
.service-cards {
    background-color: transparent;
    border: none;
}

.service-icon {
    width: 4rem;
    height: 4rem;
    object-fit: contain;
    flex-shrink: 0;
}

.arrow-link i {
    font-size: 2rem;
    color: #ff2eb2;
    transition: color 0.3s ease;
}

.arrow-link:hover i {
    color: #ffffff;
}
</style>
